import React from 'react';
import { TFunction } from 'i18next';
import { CONTACT_INDEX } from '@sizeid/shared/constants/routes';
import Button from '@sizeid/commons/components/Button';
import { WithTranslation } from 'next-i18next';

import Tooltip from 'components/Tooltip';
import { withTranslation } from 'lib/i18n';

import { VariantsType } from '../variants';
import questionmark from '../assets/questionmark.svg';
import checkmarkGrey from '../assets/checkmark-grey.svg';
import checkmarkWhite from '../assets/checkmark-white.svg';

import DesktopTableWrap from './styled/DesktopTableWrap';

export const formatValue = (
  tariffName: string,
  key: string,
  value:
    | string
    | number
    | boolean
    | Record<string, string | number>
    | typeof Infinity,
  language: string,
  t: TFunction,
): React.ReactNode => {
  if (key === 'price' && value === 'contact') {
    return (
      <Button link={CONTACT_INDEX.route}>
        {t(`business.organizations.index.contact_us`)}
      </Button>
    );
  }
  if (value === 'tailored') {
    return t('business.index.pricing.table.tailored');
  }
  if (key === 'price' && typeof value === 'object') {
    return language === 'cs'
      ? `${value.czk} ${t('currency')}`
      : `${value.eur} €`;
  }
  if (typeof value === 'boolean') {
    if (value === true) {
      return (
        <img
          src={tariffName === 'free' ? checkmarkGrey : checkmarkWhite}
          alt="check mark"
        />
      );
    }
    return '-';
  }
  if (value === Infinity) {
    return t('business.index.pricing.table.infinity');
  }
  return value;
};

type DesktopTableProps = WithTranslation & {
  variants: VariantsType;
};

const DesktopTable: React.FC<DesktopTableProps> = ({ variants, t, i18n }) => (
  <DesktopTableWrap>
    <table cellSpacing="0">
      <thead>
        <tr>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th />
          {variants.map(variant => (
            <th key={variant.code}>
              <span>
                {t(`business.index.pricing.table.col_names.${variant.code}`)}
              </span>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.entries(variants[0].values).map(([key]) => {
          const row = t(`business.index.pricing.table.row_names.${key}`);
          const tooltip = t(`business.index.pricing.table.row_tooltips.${key}`);
          return (
            <tr key={key}>
              <td>
                <span>
                  {row}
                  {key !== 'price' && (
                    <Tooltip message={t(tooltip)} direction="left">
                      <img src={questionmark} alt="Question mark" />
                    </Tooltip>
                  )}
                </span>
              </td>
              {variants.map(variant => {
                const value =
                  variant.values[key as keyof typeof variant.values];
                return (
                  <td key={variant.code}>
                    <span>
                      {formatValue(variant.code, key, value, i18n.language, t)}
                    </span>
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  </DesktopTableWrap>
);

export default withTranslation('pages')(DesktopTable);
